import React, { useState, useEffect } from 'react';
import { TextField, Box, Button, Grid, IconButton, MenuItem, Select, Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import propTypes from 'prop-types';
// Add this import for the help icon
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
// Add import for Autocomplete
import Autocomplete from '@mui/material/Autocomplete';
import { patchProposalProject } from 'ProposalProject/ProposalProject/Domain/Services/PatchProposalProjectService';
import { deleteDocument } from 'Document/Domain/Services/DeleteDocumentService';
import { getDepartmentsList } from 'Department/Domain/Services/GetDepartmentsListService';
// import { getProposalProjectObjectiveList } from 'ProposalProject/ProposalProjectObjective/Domain/Services/GetProposalProjectObjectiveListService';
// import { getProposalProjectObjectiveOperationalList } from 'ProposalProject/ProposalProjectObjectiveOperational/Domain/Services/GetProposalProjectObjectiveOperationalListService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { createProposalProjectAffectionDepartment } from 'ProposalProject/ProposalProjectAffectionDepartment/Domain/Services/CreateProposalProjectAffectionDepartmentService';
import { createProposalProjectObjective } from 'ProposalProject/ProposalProjectObjective/Domain/Services/CreateProposalProjectObjectiveService';
import { v4 as uuidv4 } from 'uuid';
import { deleteProposalProjectAffectionDepartment } from 'ProposalProject/ProposalProjectAffectionDepartment/Domain/Services/DeleteProposalProjectAffectionDepartmentService';
import { deleteProposalObjective } from 'ProposalProject/ProposalProjectObjective/Domain/Services/DeleteProposalProjectObjectiveService';
import { deleteProposalObjectiveOperational } from 'ProposalProject/ProposalProjectObjectiveOperational/Domain/Services/DeleteProposalProjectObjectiveOperationalService';
import { createProposalProjectObjectiveOperational } from 'ProposalProject/ProposalProjectObjectiveOperational/Domain/Services/CreateProposalProjectObjectiveOperationalService';
import { patchProposalProjectAffectionDepartment } from 'ProposalProject/ProposalProjectAffectionDepartment/Domain/Services/PatchProposalProjectAffectionDepartmentService';
import { patchProposalProjectObjectiveOperational } from 'ProposalProject/ProposalProjectObjectiveOperational/Domain/Services/PatchProposalProjectObjectiveOperationalService';
import { patchProposalProjectObjective } from 'ProposalProject/ProposalProjectObjective/Domain/Services/PatchProposalProjectObjectiveService';
import { ProposalProjectConstants } from 'ProposalProject/ProposalProject/Domain/Model/ProposalProjectConstant';
import { toast } from 'react-toastify';
import SearchableSelect from 'UI/Application/Components/Menus/generic/SearchableSelect';
import { getUsersList } from 'User/Domain/Services/GetUsersListService';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { ADMIN_PROPOSAL_PROJECT, OWNER_PROPOSAL_PROJECT, USER_PROPOSAL_PROJECT } from 'Shared/Security/Application/Constants/PermissionsConstant';
// Update the FirstStep prop types to include readOnly and currentStatus

const FirstStep = ({ 
    idProposalProject, 
    titleProposalProject, 
    descriptionProposalProject, 
    documentsProposalProject,
    userOwnerProposalProject, 
    affectionRowsProposalProject, 
    objectivesProposalProject, 
    objectivesOperationalProposalProject,
    permissionsProposalProject,
    reloadData,
    readOnly = false,
    currentStatus
    }) => {
    const { isAdmin, checkPermission } = useAuthContext();
    const [affectionRows, setAffectionRows] = useState([{department: '', impactLevel: '' }]);    
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    const [dataToDelete, setDataToDelete] = useState(null);
    const [objectiveRows, setObjectiveRows] = useState([]);
    const [operationalObjectiveRows, setOperationalObjectiveRows] = useState([]);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [newTitle, setNewTitle] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [sendingApiRequest, setSendingApiRequest] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [impacts, setImpacts] = useState([]);
    const [departments, setDepartments] = useState([]);
    // const [objectives, setObjectives] = useState([]);
    // const [operationalObjectives, setOperationalObjectives] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    // Add new state variables for users
    const [users, setUsers] = useState([]);
    const [selectedUserOwner, setSelectedUserOwner] = useState(userOwnerProposalProject);

    async function fetchData() {

        permissionsProposalProject = permissionsProposalProject || '';

        setSendingApiRequest(true);
        setNewTitle(titleProposalProject || '');        
        setNewDescription(descriptionProposalProject || '');

        const cierreFileName = `${idProposalProject}_requerimientos_iniciales_cierre.docx`;

        const cleanedDocuments = (documentsProposalProject || [])
            .filter(doc => {
                const fileName = doc.fileName || doc.name || '';
                return fileName !== cierreFileName; // ❌ eliminar el de cierre
            })
            .map(doc => {
                const isInitial = !!doc.isInitialRequirement;
                return {
                    ...doc,
                    isInitialRequirement: isInitial
                };
            });

        setDocuments(cleanedDocuments);
        
        const mappedAffectionRows = (affectionRowsProposalProject || []).map((row) => ({
            ...row,
            id: uuidv4(),
            existing: true,
            // Normalizamos a string para el UI
            department: row?.department !== undefined && row?.department !== null ? String(row.department) : '',
            originalDepartment: row?.department !== undefined && row?.department !== null ? String(row.department) : ''
        }));

        setAffectionRows(mappedAffectionRows);

        // Inicializamos los seleccionados para evitar duplicados y asegurar visibilidad del seleccionado
        const initiallySelected = mappedAffectionRows
            .filter((r) => r.department)
            .map((r) => String(r.department));
        setSelectedDepartments(initiallySelected);

        await getDepartmentsList({ limit: 1000, offset: 0 }).then((response) => {
            if (response) {
                setDepartments(response.records);
            }
        });
        
        // Load users list
        await getUsersList().then((response) => {
            if (response) {
                setUsers(response.records);
            }
        });

        // setObjectives(objectivesProposalProject || []);
        // if (objectivesProposalProject && objectivesProposalProject.length > 0) {
        //     const initialObjectiveRows = objectivesProposalProject.map((objective) => ({
        //         id: uuidv4(),
        //         objective: objective.id,
        //         existing: true,
        //         originalObjective: objective.id,
        //     }));
        //     setObjectiveRows(initialObjectiveRows);
        // } else {
        //     setObjectiveRows([]);
        // }

        // setOperationalObjectives(objectivesOperationalProposalProject || []);
        // if (objectivesOperationalProposalProject && objectivesOperationalProposalProject.length > 0) {
        //     const initialOperationalObjectiveRows = objectivesOperationalProposalProject.map((objective) => ({
        //         id: uuidv4(), // Generar un id único para cada fila
        //         objective: objective.id, // Usar el id del objetivo como valor seleccionado
        //         existing: true, // Marcar como fila existente
        //         originalObjective: objective.id // Guardar el objetivo original para comparar cambios
        //     }));
        //     setOperationalObjectiveRows(initialOperationalObjectiveRows);
        // } else {
        //     setOperationalObjectiveRows([]);
        // }

        await fetch('/api/v1/impactsEnums') 
            .then((response) => response.json())
            .then((data) => {
                setImpacts(data);
            })
        .catch(() => {
            //console.error('Error al obtener los niveles de impacto:', error);
        });
        
        // await getProposalProjectObjectiveList().then((response) => {
        //     if (response) {
        //         setObjectives(response);
        //     }
        // });

        // await getProposalProjectObjectiveOperationalList().then((response) => {
        //     if (response) {
        //         setOperationalObjectives(response);
        //     }
        // });   
        
        if (titleProposalProject && descriptionProposalProject && documentsProposalProject && affectionRowsProposalProject && objectivesProposalProject, objectivesOperationalProposalProject) {
            setSendingApiRequest(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [titleProposalProject, descriptionProposalProject, documentsProposalProject, affectionRowsProposalProject, objectivesProposalProject, objectivesOperationalProposalProject]);


    var originalIdProposalProject = idProposalProject;
    idProposalProject = 'PR-' + idProposalProject;

    const handleTitleChange = (event) => setNewTitle(event.target.value);
    const handleDescriptionChange = (event) => setNewDescription(event.target.value);

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        setDocuments((prevFiles) => {
            let updatedPrevFiles = [...prevFiles];

            selectedFiles.forEach((newFile) => {
                const fileName = newFile.name;
                const prevIndex = updatedPrevFiles.findIndex(
                    (prevFile) =>
                        (prevFile.name || prevFile.fileName) === fileName
                );

                if (prevIndex !== -1) {
                    // Oculta el anterior
                    updatedPrevFiles[prevIndex].hidden = true;
                    updatedPrevFiles[prevIndex].isInitialRequirement = false;
                }

                // El nuevo archivo se añade visible
                newFile.documentNew = true;
                newFile.hidden = false;
                // El check solo se marca si el nombre es exactamente el requerido
                newFile.isInitialRequirement = fileName === `${idProposalProject}_requerimientos_iniciales.docx`;
                newFile.tempId = `${newFile.name}_${newFile.lastModified}`;
                updatedPrevFiles.push(newFile);
            });

            return updatedPrevFiles;
        });
    };

    
    // const addObjectiveRow = () => setObjectiveRows([...objectiveRows, { id: objectiveRows.length + 1, objective: '' }]);
    // const addOperationalObjectiveRow = () => setOperationalObjectiveRows([...operationalObjectiveRows, { id: operationalObjectiveRows.length + 1, objective: '' }]);

    const addDepartmentRow = () => {
        const availableDepartments = departments.filter(
            (dept) => !selectedDepartments.includes(String(dept.id))
        );
    
        if (availableDepartments.length === 0) {
            alert('No hay más departamentos disponibles.');
            return;
        }
    
        setAffectionRows((prevRows) => [
            ...prevRows,
            { id: uuidv4(), department: '', impactLevel: '' },
        ]);
    };
    
    const removeAffectionRow = (id) => {
        setAffectionRows((prevRows) => {
            const updatedRows = prevRows.filter((row) => row.id !== id);
    
            const newSelectedDepartments = updatedRows
                .filter((row) => row.department)
                .map((row) => String(row.department));
    
            setSelectedDepartments(newSelectedDepartments);
            return updatedRows;
        });
    };
    
    
    const handleAffectionChange = (id, field, value) => {
        setAffectionRows((prevRows) => {
            const updatedRows = prevRows.map((row) =>
                row.id === id ? { ...row, [field]: value } : row
            );
    
            if (field === 'department') {
                const newSelectedDepartments = updatedRows
                    .filter((row) => row.department) // Solo filas con departamentos seleccionados
                    .map((row) => String(row.department));
                setSelectedDepartments(newSelectedDepartments);
            }
    
            return updatedRows;
        });
    };
    

    const removeObjectiveRow = (id) => setObjectiveRows(objectiveRows.filter(row => row.id !== id));
    const removeOperationalObjectiveRow = (id) => setOperationalObjectiveRows(operationalObjectiveRows.filter(row => row.id !== id));


    // const handleObjectiveChange = (id, value) => {
    //     const updatedRows = objectiveRows.map(row => (row.id === id ? { ...row, objective: value } : row));
    //     setObjectiveRows(updatedRows);
    // };

    // const handleOperationalObjectiveChange = (id, value) => {
    //     const updatedRows = operationalObjectiveRows.map(row => (row.id === id ? { ...row, objective: value } : row));
    //     setOperationalObjectiveRows(updatedRows);
    // };

    const handleSubmit = async (event, workflowAction) => {
        event.preventDefault();
        // verificar que no esté vacio affectionsRows

        const hasEmptyFields = affectionRows.some(
            (row) => !row.department || !row.impactLevel
        );

        if (hasEmptyFields) {
            setOpenDialogError(true);
            return;
        }

        try {
            if (sendingApiRequest) return;
            setSendingApiRequest(true);

            const filesToDelete = documents.filter(file => file.hidden && file.id);
            for (const file of filesToDelete) {
                try {
                    await deleteDocument(file.id);
                } catch (e) {
                    // Maneja el error si quieres
                }
            }

            // Solo guarda los visibles
            const files = await Promise.all(
                documents
                    .filter(file => !file.hidden)
                    .map((file) => {
                        if (file.documentNew) {
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () => resolve({
                                    name: file.name,
                                    data: reader.result,
                                    documentNew: true,
                                    isInitialRequirement: file.isInitialRequirement
                                });
                                reader.onerror = (error) => reject(error);
                                reader.readAsDataURL(file);
                            });
                        }
                        return Promise.resolve({
                            name: file.name || file.fileName,
                            data: file.path || file.data,
                            documentNew: false,
                            isInitialRequirement: file.isInitialRequirement
                        });
                    })
            );

            // Separar filas nuevas y existentes
            const rowsToCreateAffection = affectionRows.filter((row) => !row.existing);
            const rowsToEditAffection = affectionRows.filter((row) => row.existing);

            // Crear nuevas filas
            let response = false;
            let responseNeeded = false;
            if (rowsToCreateAffection.length > 0) {
                rowsToCreateAffection.forEach((row) => {
                    row.proposalProject = parseInt(idProposalProject.substring(3));
                    // Cast a number para API
                    row.department = row.department ? parseInt(row.department, 10) : null;
                });
                responseNeeded = true;
                response = await createProposalProjectAffectionDepartment({ items: rowsToCreateAffection });
            }

            // Editar filas existentes
            for (const row of rowsToEditAffection) {
                const { originalDepartment, department, impactLevel } = row;
            
                if (originalDepartment !== department) {
                    responseNeeded = true;
                    response = await patchProposalProjectAffectionDepartment(
                        {
                            proposalProject: parseInt(idProposalProject.substring(3)),
                            // Cast a number para API
                            originalDepartment: originalDepartment ? parseInt(originalDepartment, 10) : null,
                            department: department ? parseInt(department, 10) : null,
                            impactLevel,
                        }
                    );
                }
            }

            var apiResponse = await patchProposalProject(parseInt(idProposalProject.substring(3)), {
                status: 'status',
                title: newTitle,
                description: newDescription,
                documents: files,
                workflowAction: workflowAction,
                userOwnerId: selectedUserOwner || null // Include the selected user
            });

            // Filtrar filas vacías
            const filteredObjectiveRows = objectiveRows.filter((row) => row.objective);
            const filteredOperationalObjectiveRows = operationalObjectiveRows.filter((row) => row.objective);

            // Actualizar los estados para reflejar los cambios
            setObjectiveRows(filteredObjectiveRows);
            setOperationalObjectiveRows(filteredOperationalObjectiveRows);

            // Gestionar las filas de "objective"
            const rowsToCreateObjective = filteredObjectiveRows.filter((row) => !row.existing);
            const rowsToEditObjective = filteredObjectiveRows.filter((row) => row.existing);

            if (rowsToCreateObjective.length > 0) {
                rowsToCreateObjective.forEach((row) => {
                    row.proposalProject = parseInt(idProposalProject.substring(3));
                });
                await createProposalProjectObjective({ items: rowsToCreateObjective });
            }

            for (const row of rowsToEditObjective) {
                const { originalObjective, objective } = row;

                // Solo llamar a patch si hay un cambio
                if (originalObjective !== objective) {
                    await patchProposalProjectObjective({
                        objective,
                        proposalProject: parseInt(idProposalProject.substring(3)),
                        originalObjective
                    });
                }
            }

            // Gestionar las filas de "operationalObjective"
            const rowsToCreateOperationalObjective = filteredOperationalObjectiveRows.filter((row) => !row.existing);
            const rowsToEditOperationalObjective = filteredOperationalObjectiveRows.filter((row) => row.existing);

            if (rowsToCreateOperationalObjective.length > 0) {
                rowsToCreateOperationalObjective.forEach((row) => {
                    row.proposalProject = parseInt(idProposalProject.substring(3));
                });
                await createProposalProjectObjectiveOperational({ items: rowsToCreateOperationalObjective });
            }

            if (files.filter(file => file.isInitialRequirement).length > 1) {
                toast.error('Solo se puede marcar un archivo como requerimiento inicial.');
                setSendingApiRequest(false);
                return;
            }

            for (const row of rowsToEditOperationalObjective) {
                const { originalObjective, objective } = row;
                if (originalObjective !== objective) {
                    await patchProposalProjectObjectiveOperational({
                        objective,
                        proposalProject: parseInt(idProposalProject.substring(3)),
                        originalObjective,
                    });
                }
            }

            if (
                apiResponse
                &&
                (
                    (responseNeeded && response)
                    ||
                    !responseNeeded
                )
            ) {
                if (workflowAction === null) setOpenSaveDialog(true);
                reloadData();
            } else {

                // si marca un el check de "Es requerimiento inicial" y el archivo no es docx sale un toast de error
                if (files.some(file => file.isInitialRequirement && !file.name.endsWith('.docx'))) {
                    toast.error('El archivo marcado como requerimiento inicial debe ser un documento Word (.docx).');
                    setSendingApiRequest(false);
                    return;
                }
                
                toast.error('Error al enviar los datos. Revisa el formulario.');
            }
            
            setSendingApiRequest(false);



        } catch (error) {
            //console.error(error);
            alert('Error al enviar los datos.');
        }
        
    };

    const handleCloseSaveDialog = () => setOpenSaveDialog(false);

        // Abre el dialog para confirmar eliminación
        const confirmDelete = (data, type) => {
            const dataWithType = { ...data, type: type };
            setDataToDelete(dataWithType);        
            setOpenDialog(true);
        };
        const handleConfirmDelete = async () => {
            if (dataToDelete && dataToDelete.type === 'document') {
                // Si no tiene ID, es un archivo nuevo
                if (!dataToDelete.id) {
                    setDocuments((prevDocuments) =>
                        prevDocuments.filter((file) => file.tempId !== dataToDelete.tempId)
                    );
                    toast.success('Archivo eliminado correctamente');
                    setOpenDialog(false);
                    setDataToDelete(null);
                    return;
                }

                // Documento existente con ID
                setSendingApiRequest(true);
                try {
                    const apiResponse = await deleteDocument(dataToDelete.id);
                    if (apiResponse) {
                        setDocuments((prevDocuments) =>
                            prevDocuments.filter((file) => file.id !== dataToDelete.id)
                        );
                        toast.success('Archivo eliminado correctamente');
                    } else {
                        toast.error('Error al eliminar el documento del servidor.');
                    }
                } catch (error) {
                    toast.error('Error al eliminar el documento.');
                } finally {
                    setSendingApiRequest(false);
                    setOpenDialog(false);
                    setDataToDelete(null);
                }
            }

    
    
            if (dataToDelete && dataToDelete.type === 'affection') {
                
                if (dataToDelete.impactLevel === "" && dataToDelete.department === "" || !dataToDelete.existing) {
                    removeAffectionRow(dataToDelete.id);
                    setOpenDialog(false);
                    setDataToDelete(null);
                    return;
                }
                                
                setSendingApiRequest(true);
                try {
                    
                    // Llama a la API para eliminar la afectación
                    const response = await deleteProposalProjectAffectionDepartment(
                        parseInt(idProposalProject.substring(3)),
                        dataToDelete?.department ? parseInt(dataToDelete.department, 10) : null
                    );                    
                    if (response) {
                        //console.log('Afectación eliminada con éxito');
                       
                        removeAffectionRow(dataToDelete.id);
    
                    } else {
                        //console.error('Error al eliminar la afectación en el servidor.');
                    }
                } catch (error) {
                    //console.error('Error en la eliminación de la afectación:', error);
                } finally {
                    setSendingApiRequest(false);
                    setOpenDialog(false);
                    setDataToDelete(null);
                }
            }

            if (dataToDelete && dataToDelete.type === 'objective') {
                    
                if (dataToDelete.objective === "" || !dataToDelete.existing) {
                    removeObjectiveRow(dataToDelete.id);
                    setOpenDialog(false);
                    setDataToDelete(null);
                    return;
                }
                                
                setSendingApiRequest(true);
                try {
                    
                    // Llama a la API para eliminar la afectación
                    const response = await deleteProposalObjective(parseInt(idProposalProject.substring(3)), dataToDelete.objective);                    
                    if (response) {
                        //console.log('Objetivo eliminado con éxito');
                    
                        removeObjectiveRow(dataToDelete.id);
    
                    } else {
                        //console.error('Error al eliminar el objetivo en el servidor.');
                    }
                } catch (error) {
                    //console.error('Error en la eliminación del objetivo:', error);
                } finally {
                    setSendingApiRequest(false);
                    setOpenDialog(false);
                    setDataToDelete(null);
                }
            }

            if (dataToDelete && dataToDelete.type === 'objectiveOperational') {
                        
                if (dataToDelete.objective === "" || !dataToDelete.existing) {
                    removeOperationalObjectiveRow(dataToDelete.id);
                    setOpenDialog(false);
                    setDataToDelete(null);
                    return;
                }
                                
                setSendingApiRequest(true);
                try {
                    //console.log(dataToDelete);
                    // Llama a la API para eliminar la afectación
                    const response = await deleteProposalObjectiveOperational(parseInt(idProposalProject.substring(3)), dataToDelete.objective);                    
                    if (response) {
                        //console.log('Objetivo Operacional eliminado con éxito');
                    
                        removeOperationalObjectiveRow(dataToDelete.id);
    
                    } else {
                        //console.error('Error al eliminar el objetivo operacional en el servidor.');
                    }
                } catch (error) {
                    //console.error('Error en la eliminación del objetivo operacional:', error);
                } finally {
                    setSendingApiRequest(false);
                    setOpenDialog(false);
                    setDataToDelete(null);
                }
            }

                
        };
    
        // Cierra el dialog sin eliminar
        const handleCloseDialog = () => {
            setOpenDialog(false);
            setOpenDialogError(false);
            setDataToDelete(null);
        };
    
        const handleViewDocument = async (base64FileName) => {
            try {
                const fileURL = "/api/v1/blob-storage/" + base64FileName;
                window.open(fileURL, '_blank');
            } catch (error) {
                //console.error('Error al obtener el documento:', error);
                alert('No se pudo obtener el documento.');
            }
        };

    // Add a function to conditionally render action buttons based on readOnly
    const renderActionButtons = () => {
        // If in read-only mode, show a message instead of buttons
        if (readOnly) {
            return (
                <>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        Vista en modo de solo lectura.
                    </Typography>
                    <Typography variant="h6" mt={4} color="textSecondary">
                        {currentStatus !== undefined && currentStatus !== titleProposalProject && 
                        `La propuesta no está en este estado.`}
                    </Typography>
                </>
            );
        }

        // Normal buttons when not in read-only mode
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Button 
                    variant="contained" 
                    type="submit" 
                    style={{ marginTop: '35px', marginRight: '10px' }}
                    onClick={(e) => {handleSubmit(e, null)}}
                >Guardar</Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    style={{ marginTop: '35px' }}
                    onClick={(e) => {handleSubmit(e, ProposalProjectConstants.WORKFLOW_STEP1_TO_STEP2)}}
                >Siguiente Paso</Button>
            </div>
        );
    };

    // Modify the return section - updating input fields to be disabled and hiding add/delete buttons in read-only mode
    return (
        <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', textAlign: 'center', marginTop: '10px', border: '1px solid #ccc' }}>
            <Box sx={{ p: 4 }}>
                <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6">Datos Generales</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información básica del proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Usuario:</b> Persona asignada al proyecto</li>
                                    <li><b>Nombre proyecto:</b> Título descriptivo para el proyecto</li>
                                    <li><b>ID Proyecto:</b> Identificador único para este proyecto</li>
                                    <li><b>Descripción:</b> Descripción detallada del proyecto y sus objetivos</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>

                <Grid container spacing={2} my={2}>
                    {/* Replace Select with Autocomplete for better user searching */}
                    <Grid item xs={12} sm={12}>
                        <Autocomplete
                            id="user-select"
                            options={users}
                            getOptionLabel={(option) => 
                                option.name ? `${option.name} ${option.firstSurname} ${option.secondSurname}` : ''
                            }
                            value={users.find(user => user.id === selectedUserOwner) || null}
                            onChange={(event, newValue) => {
                                setSelectedUserOwner(newValue ? newValue.id : '');
                            }}
                            disabled={
                                (
                                    readOnly
                                    ||
                                    (
                                        !readOnly // No estamos en modo solo lectura
                                        &&
                                        !isAdmin() // No somos admin
                                        &&
                                        (
                                            checkPermission(OWNER_PROPOSAL_PROJECT) // Tenemos el permiso de owner
                                            &&
                                            // No tenemos user o admin, significa que somo solo owner y nada más
                                            (
                                                !checkPermission(USER_PROPOSAL_PROJECT)
                                                ||
                                                !checkPermission(ADMIN_PROPOSAL_PROJECT)
                                            )
                                        )
                                    )
                                )
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Persona Responsable"
                                    variant="outlined"
                                    fullWidth
                                    placeholder="Buscar persona..."
                                />
                            )}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props}>
                                        {option.name} {option.firstSurname} {option.secondSurname}
                                    </li>
                                );
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField 
                            fullWidth 
                            label="Nombre proyecto" 
                            variant="outlined" 
                            onChange={handleTitleChange} 
                            value={newTitle} 
                            disabled={readOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="ID Proyecto" variant="outlined" value={idProposalProject} disabled />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            fullWidth 
                            multiline 
                            rows={4} 
                            label="Descripción" 
                            variant="outlined" 
                            onChange={handleDescriptionChange} 
                            value={newDescription} 
                            disabled={readOnly}
                        />
                    </Grid>
                </Grid>
                
                {/* Hide upload button in read-only mode */}
                {!readOnly && (
                    <Box sx={{ mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Typography variant="h6">Documentos</Typography>
                        <Tooltip
                            title={
                                <Box sx={{ p: 1 }}>
                                    <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                        Adjunte cualquier documento relevante para el proyecto.
                                    </Typography>
                                    <br />
                                    <br />
                                    <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                        Ejemplos: Especificaciones técnicas
                                    </Typography>
                                </Box>
                            }
                            arrow
                            placement="right"
                            sx={{ maxWidth: '400px' }}
                        >
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                                <IconButton size="small" color="primary">
                                    <HelpOutlineIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Tooltip>
                    </Box>
                )}

                <Grid alignItems="left" mt={4}>
                    {!readOnly && (
                        <Grid item xs={4}>
                            {/* poner una coletilla indicando que la plantilla se ha de descargar y rellenar para poder seguir con la propuesta */}
                            <Typography variant="body1" color="textSecondary" mb={1}>
                                *Descargue la plantilla para rellenar los datos necesarios del proyecto.
                            </Typography>
                            <Button
                                variant="outlined"
                                href={`/api/v1/proposal-project/${originalIdProposalProject}/generate-word-initial-requirements`}
                                target="_blank"
                                style={{ marginRight: '10px' }}
                            >
                                Descargar Plantilla
                            </Button>
                            
                            <Button variant="contained" component="label">
                                Subir Archivos
                                <input type="file" hidden multiple onChange={handleFileChange} />
                            </Button>                      
                        </Grid>
                    )}
                </Grid>

                {/* Showing documents without delete buttons in read-only mode */}
                <Grid container spacing={2}>
                    {documents
                        .filter(file => 
                            !file.hidden &&
                            (file.fileName || file.name) !== `${idProposalProject}_requerimientos_iniciales_cierre.docx`
                        )
                        .map((file, index) => {
                        const requiredName = `${idProposalProject}_requerimientos_iniciales.docx`;
                        const isInitialRequirement = (file.fileName || file.name) === requiredName;
                        const isExistingFile = !file.documentNew && (file.id || file.path);

                        // Revisamos la lógica para excluir efectivamente cualquier documento de cierre
                        const cierreFileName = `${idProposalProject}_requerimientos_iniciales_cierre.docx`;

                        const existsRequired = documents.some(f => {
                            const fileName = f.fileName || f.name || '';

                            // Ignorar si es el documento de cierre exacto o está oculto
                            if (fileName === cierreFileName || f.hidden || f === file) {
                                return false;
                            }

                            // Solo cuenta si es el requerido inicial o tiene la marca
                            return (fileName === requiredName || !!f.isInitialRequirement);
                        });


                        // Determinar si mostrar el checkbox:
                        // - Siempre se muestra si es el archivo oficial de requerimientos iniciales
                        // - No se muestra para archivos existentes que no sean el oficial
                        // - Se muestra para archivos nuevos
                        const showCheckbox = isInitialRequirement || !isExistingFile;

                        // Determinar si este checkbox debe estar deshabilitado
                        const isCheckboxDisabled = readOnly || isInitialRequirement || existsRequired;

                        return (
                            <Grid item key={index + '-doc'} xs={12} sm={6} md={4} lg={3} marginTop={3}>
                                <Paper sx={{ 
                                    p: 2, 
                                    position: 'relative', 
                                    textAlign: 'center',
                                    minHeight: '120px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    overflow: 'hidden'
                                }}>
                                    <Typography variant="body2" sx={{ 
                                        mb: 1, 
                                        position: 'relative', 
                                        paddingRight: !readOnly ? '24px' : '0',
                                        wordBreak: 'break-word' 
                                    }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => handleViewDocument(file.path)}
                                            style={{ 
                                                marginTop: '10px', 
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                            sx={{
                                                whiteSpace: 'nowrap',
                                                '& .MuiButton-label': {
                                                    display: 'block',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }
                                            }}
                                            title={file.fileName || file.name} // Show full name on hover
                                        >
                                            {(file.fileName || file.name).length > 20 
                                                ? (file.fileName || file.name).substring(0, 17) + '...' 
                                                : (file.fileName || file.name)
                                            }
                                        </Button>
                                    </Typography>
                                    {!readOnly && showCheckbox && (
                                        <Box mt={1}>
                                            <label 
                                                style={{ 
                                                    fontSize: '0.875rem',
                                                    cursor: isCheckboxDisabled ? 'not-allowed' : 'pointer' 
                                                }}
                                                onClick={(e) => {
                                                    // Si está deshabilitado, mostrar motivo
                                                    if (isCheckboxDisabled && !isInitialRequirement) {
                                                        e.preventDefault();
                                                        toast.info('Ya hay otro archivo marcado como requerimiento inicial.');
                                                    }
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={isInitialRequirement || !!file.isInitialRequirement}
                                                    disabled={isCheckboxDisabled}
                                                    onChange={e => {
                                                        if (!isCheckboxDisabled) {
                                                            const updated = [...documents];
                                                            updated[index].isInitialRequirement = e.target.checked;
                                                            setDocuments(updated);
                                                            
                                                            if (e.target.checked && 
                                                                !(file.name || "").endsWith('.docx')) {
                                                                toast.warning('El archivo de requerimientos iniciales debe ser un documento Word (.docx)');
                                                            }
                                                        }
                                                    }}
                                                />{' '}
                                                ¿Es requerimiento inicial?
                                            </label>
                                        </Box>
                                    )}
                                    {!readOnly && (
                                        <IconButton
                                            sx={{ 
                                                position: 'absolute', 
                                                top: 5, 
                                                right: 5,
                                                zIndex: 2
                                            }}
                                            onClick={() => confirmDelete(file, 'document')}
                                        >
                                            <DeleteIcon color="error" fontSize="small" />
                                        </IconButton>
                                    )}
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>


                
                {/* Explanatory text for Afectación section */}
                <Box sx={{ mt: 4, mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6">Afectación</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    En esta sección se indica qué departamentos se verán afectados por el proyecto y el nivel de impacto sobre cada uno.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Ejemplo: El departamento de IT tendrá un impacto ALTO mientras que el departamento de Marketing un impacto MEDIO.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Departamento:</b> Área funcional afectada por el proyecto</li>
                                    <li><b>Impacto:</b> Nivel de afectación (Alto, Medio, Bajo)</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>

                {/* Departamentos e Impactos */}
                <Paper
                    sx={{
                        p: 2,
                        backgroundColor: '#e0f7fa',
                        width: '100%',
                        margin: '0 auto',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Grid container spacing={2} sx={{display:'flex', justifyContent:'center'}} mb={2}>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    backgroundColor: '#0492D4',
                                    color: 'white',
                                    p: 1,
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                    fontSize: '1rem',
                                }}
                            >
                                Departamento
                            </Typography>
                        </Grid>
                        <Grid item xs={readOnly ? 6 : 5}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    backgroundColor: '#0492D4',
                                    color: 'white',
                                    p: 1,
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                    fontSize: '1rem',
                                }}
                            >
                                Impacto
                            </Typography>
                        </Grid>
                        {/* Hide add button in read-only mode */}
                        {!readOnly && (
                            <Grid item display="flex" xs={1} justifyContent="center">
                                <IconButton size="medium" onClick={addDepartmentRow}>
                                    <AddCircleOutlineIcon fontSize="medium" color="primary" />
                                </IconButton>
                            </Grid>
                        )}
                    </Grid>

                    {affectionRows.map((row) => (
                        <Grid container spacing={2} key={row.id+'-af'} sx={{ display: 'flex', justifyContent: 'center' }} mb={1}>
                            <Grid item xs={6}>
                                <SearchableSelect
                                    options={departments.filter(
                                        (dept) => !selectedDepartments.includes(String(dept.id)) || String(dept.id) === String(row.department)
                                    )}
                                    value={row.department ? String(row.department) : ''}
                                    onChange={(e) => handleAffectionChange(row.id, 'department', e.target.value)}
                                    disabled={readOnly}
                                    placeholder="Seleccione un departamento"
                                    renderOption={(option) => option.name}
                                />
                            </Grid>
                            <Grid item xs={readOnly ? 6 : 5}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={row.impactLevel}
                                    onChange={(e) => handleAffectionChange(row.id, 'impactLevel', e.target.value)}
                                    disabled={readOnly}
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una opción</em>
                                    </MenuItem>
                                    {impacts.map((impact) => (
                                        <MenuItem key={impact.key+'-imp'} value={impact.key}>
                                            {impact.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {/* Hide delete button in read-only mode */}
                            {!readOnly && (
                                <Grid item display="flex" justifyContent="center" xs={1}>
                                    <IconButton onClick={() => confirmDelete(row,'affection')} size="medium">
                                        <DeleteIcon fontSize="medium" />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                </Paper>
                
              
                {/* <Box sx={{ mt: 4, mb: 2, width: "100%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6">Objetivos</Typography>
                    <Tooltip
                        title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Seleccione los objetivos y objetivos operacionales relacionados con este proyecto.
                                </Typography>
                                <br />
                                <br />
                                <Typography variant="text" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    Información sobre los campos:
                                </Typography>
                                <ul style={{ margin: '0', paddingLeft: '16px' }}>
                                    <li><b>Objetivo:</b> Objetivos</li>
                                    <li><b>Objetivo Operacional:</b> Objetivos Operacionales</li>
                                </ul>
                            </Box>
                        }
                        arrow
                        placement="right"
                        sx={{ maxWidth: '400px' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography variant="caption" color="primary">¿Tienes dudas?</Typography>
                            <IconButton size="small" color="primary">
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>

                <Grid
                    container
                    spacing={2}
                    sx={{
                        justifyContent: "center",
                        alignItems: "flex-start",
                        mt: 5,
                    }}
                >
                    <Grid item xs={6}>
                        <Paper
                            sx={{
                                p: 2,
                                backgroundColor: '#e0f7fa',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                width: '95%'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center" mb={2}>
                                <Grid item xs={!readOnly ? 11 : 12}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            backgroundColor: '#0492D4',
                                            color: 'white',
                                            p: 1,
                                            borderRadius: '4px',
                                            fontSize: '1rem',
                                        }}
                                    >
                                        Objetivo
                                    </Typography>
                                </Grid>
                                {!readOnly && (
                                    <Grid item xs={1} display="flex" justifyContent="center">
                                        <IconButton size="medium" onClick={addObjectiveRow}>
                                            <AddCircleOutlineIcon fontSize="medium" color="primary" />
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            {objectiveRows.map((row) => (
                                <Grid container spacing={2} alignItems="center" key={row.id+'-obj'} mb={1}>
                                    <Grid item xs={!readOnly ? 11 : 12}>
                                    <SearchableSelect
                                        options={objectives}
                                        value={row.objective}
                                        onChange={(e) => handleObjectiveChange(row.id, e.target.value)}
                                        disabled={readOnly}
                                        placeholder="Seleccione un objetivo"
                                        renderOption={(option) => (
                                            <>
                                            <b>{option.title}</b>: {option.description}
                                            </>
                                        )}
                                    />
                                    </Grid>
                                    {!readOnly && (
                                        <Grid item xs={1} display="flex" justifyContent="center">
                                            <IconButton size="medium" onClick={() => confirmDelete(row,'objective')}>
                                                <DeleteIcon fontSize="medium" />
                                            </IconButton>
                                        </Grid>
                                    )}
                                </Grid>
                            ))}
                        </Paper>
                    </Grid>

                    <Grid item xs={6}>
                        <Paper
                            sx={{
                                p: 2,
                                backgroundColor: '#e0f7fa',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                width: '100%'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center" mb={2}>
                                <Grid item xs={!readOnly ? 11 : 12}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            backgroundColor: '#0492D4',
                                            color: 'white',
                                            p: 1,
                                            borderRadius: '4px',
                                            fontSize: '1rem',
                                        }}
                                    >
                                        Objetivo Operacional
                                    </Typography>
                                </Grid>
                                {!readOnly && (
                                    <Grid item xs={1} display="flex" justifyContent="center">
                                        <IconButton size="medium" onClick={addOperationalObjectiveRow}>
                                            <AddCircleOutlineIcon fontSize="medium" color="primary" />
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            {operationalObjectiveRows.map((row) => (
                                <Grid container spacing={2} alignItems="center" key={row.id+'-op-obj'} mb={1}>
                                    <Grid item xs={!readOnly ? 11 : 12}>
                                    <SearchableSelect
                                        options={operationalObjectives}
                                        value={row.objective}
                                        onChange={(e) => handleOperationalObjectiveChange(row.id, e.target.value)}
                                        disabled={readOnly}
                                        placeholder="Seleccione un objetivo operacional"
                                        renderOption={(option) => (
                                            <>
                                            <b>{option.title}</b>: {option.description}
                                            </>
                                        )}
                                    />
                                    </Grid>
                                    {!readOnly && (
                                        <Grid item xs={1} display="flex" justifyContent="center">
                                            <IconButton size="medium" onClick={() => confirmDelete(row,'objectiveOperational')}>
                                                <DeleteIcon fontSize="medium" />
                                            </IconButton>
                                        </Grid>
                                    )}
                                </Grid>
                            ))}
                        </Paper>
                    </Grid>
                </Grid> */}
                            

                {renderActionButtons()}
                
                 <Dialog open={openDialog} onClose={handleCloseDialog}>
                    <DialogTitle>Confirmar Eliminación</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro de que deseas eliminar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmDelete} color="error">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog de Confirmación de Éxito */}
                <Dialog open={openSaveDialog} onClose={handleCloseSaveDialog}>
                    <DialogTitle>Guardado Exitoso</DialogTitle>
                    <DialogContent>
                        <DialogContentText>El proyecto ha sido guardado exitosamente.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSaveDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* dialog de error */}
                
                <Dialog open={openDialogError} onClose={handleCloseDialog}>
                    <DialogTitle>Error</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Se debe rellenar todos los datos.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                <DialogLoader open={sendingApiRequest} />

            </Box>
        </div>
    );
};

FirstStep.propTypes = {
    idProposalProject: propTypes.string,
    titleProposalProject: propTypes.string,
    descriptionProposalProject: propTypes.string,
    documentsProposalProject: propTypes.array,
    userOwnerProposalProject: propTypes.number,
    affectionRowsProposalProject: propTypes.array,
    objectivesProposalProject: propTypes.array,
    objectivesOperationalProposalProject: propTypes.array,
    permissionsProposalProject: propTypes.string,
    reloadData: propTypes.func,
    readOnly: propTypes.bool,
    currentStatus: propTypes.string
};

export default FirstStep;